import type { LoaderFunction } from 'react-router-dom';
import { apiGetTypeMatchesGroupedByType } from "../../api/matchApi";
import { combineAdminLoader } from "./AdminRouteProtection";

const TypeMatchHandlerLoaderInternal: LoaderFunction = async () => {
    try {
        const response = await apiGetTypeMatchesGroupedByType();
        return response;
    } catch (error) {
        throw new Error('Failed to load match types');
    }
};

// Wrapper con protezione admin
export const TypeMatchHandlerLoader: LoaderFunction = combineAdminLoader(TypeMatchHandlerLoaderInternal);
